//React
import React from "react";
import {
  NavLink,
} from "react-router-dom";

//Icon


class Comp extends React.Component {
  render() {
    return (
      <div className='sub_menu' style={{maxWidth:'300px', margin:'auto'}}>
        <div className='outer'>
          <NavLink to="/my/qa/question/" className='link' activeClassName="selected">
            <div className='text' style={{padding:'10px'}}>質問</div>
          </NavLink>
          <NavLink
            to="/my/qa/answer/"
            className='link'
            activeClassName="selected"
          >
            <div className='text' style={{padding:'10px'}}>回答</div>
          </NavLink>
        </div>
      </div>
    )
  }
}

export default Comp;
